import axios from 'axios';
import axiosService from '@Lib/axiosService';
import { getBarcodeAuthToken } from '@Utils/barcodePrint';

const url = `${process.env.URL}`;

export const getOrders = (params) => {
  const { projectId, ...restParams } = params;
  return axiosService
    .get(`${url}/projects/${projectId}/orders`, restParams)
    .then((res) => res.data);
};

export const getOrderDetail = (params) => {
  const { projectId, orderId } = params;
  return axiosService
    .get(`${url}/projects/${projectId}/orders/${orderId}`)
    .then((res) => res.data.data);
};

export const editOrder = (params) => {
  const { projectId, orderId, data } = params;
  return axiosService
    .put(`${url}/projects/${projectId}/orders/${orderId}`, data)
    .then((res) => res.data.data);
};

export const deleteOrder = (params) => {
  const { projectId, data } = params;
  return axiosService.delete(`${url}/projects/${projectId}/orders`, data).then((res) => res.data);
};

export const addNewOrder = (params) => {
  const { projectId, data } = params;
  return axiosService
    .post(`${url}/projects/${projectId}/orders`, data)
    .then((res) => res.data.data);
};

export const getStatus = async ({ projectId }) => {
  return axiosService
    .get(`${url}/projects/${projectId}/orders/statusesCount`)
    .then((res) => res.data);
};

export const getTags = async () => {
  return axiosService.get(`${url}/tags`).then((res) => res.data.data);
};

export const getAllOrderStatus = () => {
  return axiosService.get(`${url}/statuses`).then((res) => res.data);
};

export const editStatus = (params) => {
  const { projectId, orderId, statusId: status_id, pivotId: pivot_id, cancelReason } = params;
  return axiosService
    .put(`${url}/projects/${projectId}/orders/${orderId}/status`, {
      status_id,
      pivot_id,
      cancel_reason: cancelReason,
    })
    .then((res) => res.data);
};

export const getComments = (params) => {
  const { projectId, orderId } = params;
  return axiosService
    .get(`${url}/projects/${projectId}/orders/${orderId}/comments`)
    .then((res) => res.data.data);
};

export const addNewComment = (params) => {
  const { projectId, orderId, body } = params;
  return axiosService
    .post(`${url}/projects/${projectId}/orders/${orderId}/comments`, body)
    .then((res) => res.data.data);
};

export const editComment = (params) => {
  const { projectId, orderId, commentId, body } = params;
  return axiosService
    .put(`${url}/projects/${projectId}/orders/${orderId}/comments/${commentId}`, body)
    .then((res) => res.data.data);
};

export const getActivities = (params) => {
  const { projectId, orderId, ...restParams } = params;
  return axiosService
    .get(`${url}/projects/${projectId}/orders/${orderId}/activities`, restParams)
    .then((res) => res.data);
};

export const makeKeySearch = (params) => {
  const { projectId, orderId } = params;
  return axiosService
    .post(`${url}/projects/${projectId}/orders/${orderId}/callHistories`)
    .then((res) => res.data);
};

export const getCallHistory = (params) => {
  const { projectId, orderId } = params;
  return axiosService
    .get(`${url}/projects/${projectId}/orders/${orderId}/callHistories`)
    .then((res) => res.data);
};

export const updateShippingCompany = (params) => {
  const { projectId, orderId, body } = params;
  return axiosService
    .put(`${url}/projects/${projectId}/orders/${orderId}/shippingCompany`, body)
    .then((res) => res.data);
};

export const getOrdersExportUrl = (params = {}) => {
  const { projectId } = params;
  const resolvedProjectId = projectId ?? 0;
  const query = new URLSearchParams();
  const ignoredKeys = ['projectId', 'page', 'per_page'];

  Object.entries(params).forEach(([key, value]) => {
    if (ignoredKeys.includes(key) || value === undefined || value === null || value === '') {
      return;
    }

    query.set(key, String(value));
  });

  return `${url}/projects/${resolvedProjectId}/orders/export${
    query.toString() ? `?${query.toString()}` : ''
  }`;
};

export const downloadOrdersExport = async (params = {}) => {
  const token = getBarcodeAuthToken();

  if (!token) {
    throw new Error('Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại');
  }

  let response;

  try {
    response = await axios.get(getOrdersExportUrl(params), {
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob',
    });
  } catch (error) {
    const errorBlob = error?.response?.data;

    if (errorBlob instanceof Blob && errorBlob.type?.includes('application/json')) {
      const errorPayload = JSON.parse(await errorBlob.text());
      throw new Error(errorPayload?.message || 'Không thể xuất Excel danh sách đơn hàng');
    }

    throw error;
  }

  const blob = new Blob([response.data], {
    type:
      response.headers['content-type'] ||
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  const dateRangeLabel = [params.created_at_from, params.created_at_to]
    .filter(Boolean)
    .map((value) => String(value).replace(/\//g, '-'))
    .join('_den_');

  link.href = downloadUrl;
  link.download = dateRangeLabel
    ? `danh-sach-don-hang-${dateRangeLabel}.xlsx`
    : 'danh-sach-don-hang.xlsx';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
};
